import {
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    makeStyles,
} from "@material-ui/core";
import { dictionary } from "../../../_helpers/dictionary";
import { Fragment } from "react";
import { useFormikContext } from "formik";

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(2),
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
    },
    errorText: {
        color: "red",
    },
}));

const ParameterPermissionsForm = ({ parameterPermissions }) => {
    const { errors, touched, values, setFieldValue } = useFormikContext();

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            {Object.keys(values)
                .filter(
                    (el) =>
                        el !== "haveNonParameterFields"
                )
                .map((el, index) => (
                    <Fragment key={index}>
                        <Grid item xs={12} className="my-6">
                            <Grid
                                container
                                spacing={3}
                                alignItems="flex-start"
                                justify="space-between"
                            >
                                <Grid item xs={8} md={4}>
                                    <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                        display {dictionary[el] || el}
                                        <span className="small d-block mt-2 line-height-lg">
                                            {
                                                parameterPermissions[el]
                                                    ?.description
                                            }
                                        </span>
                                    </InputLabel>
                                </Grid>
                                <Grid item>
                                    <FormControl
                                        required
                                        error={!!(errors && touched)}
                                        component="fieldset"
                                    >
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                className="success"
                                                name={el}
                                                checked={values[el]}
                                                onChange={(event) => {
                                                    const checked =
                                                        event.target.checked;
                                                    setFieldValue(el, checked);
                                                }}
                                            />
                                            <span className="slider" />
                                        </label>
                                    </FormControl>
                                    {errors && touched && (
                                        <FormHelperText
                                            className={classes.errorText}
                                        >
                                            {errors[el]}
                                        </FormHelperText>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        {index <
                            Object.keys(values).filter(
                                (el) => el !== "haveNonParameterFields"
                            ).length -
                                1 && <hr className="w-100" />}
                    </Fragment>
                ))}
        </Grid>
    );
};

export default ParameterPermissionsForm;
